import { Navigate, Route, Routes } from 'react-router'
import { observer } from 'mobx-react-lite'
import { InboxSettingsLayout } from 'pages/settings/pages/inboxes/pages/id/pages/settings/layout/InboxSettingsLayout'
import { SmartCallFlow } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/SmartCallFlow'
import { MembersTabContent } from 'pages/settings/pages/inboxes/pages/id/pages/members/ui/MembersTabContent/MembersTabContent'
import { InboxesAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxesAccessLayout'
import { InboxesPageLayout } from 'pages/settings/pages/inboxes/layout/InboxesPageLayout'
import { InboxesView } from 'pages/settings/pages/inboxes/pages'
import { InboxPageAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxPageAccessLayout'
import { InboxProviderLayout } from 'pages/settings/pages/inboxes/pages/id/layout/inboxProviderLayout'
import { InboxPageCallingAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxPageCallingAccessLayout'
import { InboxPageAiAutomationAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxPageAiAutomationAccessLayout'
import { InboxByIdView } from 'pages/settings/pages/inboxes/pages/id/pages/InboxByIdView'
import { NumbersTabContent } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/NumbersTabContent'
import { MessagingGeneral } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/general/MessagingGeneral'
import { AddNumbersProviderLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/layout/AddNumbersProviderLayout'
import { AddNumberRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumber'
import { ConversationAssignment } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/ConversationAssignment'
import { MessagingAiAutomation } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/ai-automation/MessagingAiAutomation'
import { BusinessHours } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/businessHours/BusinessHours'
import { InboxAddNumberAccessLayout } from 'pages/settings/pages/inboxes/layout/InboxAddNumberAccessLayout'
import { CallingGeneral } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/general/CallingGeneral'
import { SmartInbox } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/smartInbox/SmartInbox'
import { SettingsRoutes } from 'pages/settings/route/type'
import { InboxesRoutes } from './type'
import { NewInboxRouter } from './NewInboxRouter'
import { AddNumberMethodsRouter } from './AddNumberMethodsRouter'

export const InboxesRouter = observer(() => {
  return (
    <Routes>
      <Route element={<InboxesAccessLayout />}>
        <Route element={<InboxesPageLayout />}>
          <Route index element={<InboxesView />} />
          <Route element={<InboxPageAccessLayout />}>
            <Route path={`/${InboxesRoutes.new}/*`} element={<NewInboxRouter />} />
            <Route element={<InboxProviderLayout />}>
              <Route element={<AddNumbersProviderLayout />}>
                <Route path={':id'}>
                  <Route element={<InboxAddNumberAccessLayout />}>
                    <Route
                      path={`${InboxesRoutes.numbers}/${InboxesRoutes.addNumber}/*`}
                      element={<AddNumberRouter />}
                    />
                  </Route>
                  <Route path={`${InboxesRoutes.numbers}/*`} element={<AddNumberMethodsRouter />} />
                </Route>
              </Route>
              <Route element={<InboxByIdView />}>
                <Route path={':id'}>
                  <Route path={InboxesRoutes.members} element={<MembersTabContent />} />
                  <Route path={InboxesRoutes.teams} element={<div>teams</div>} />
                  <Route path={InboxesRoutes.numbers} element={<NumbersTabContent />} />
                  <Route element={<InboxSettingsLayout />}>
                    <Route path={InboxesRoutes.settings}>
                      <Route index element={<Navigate to={InboxesRoutes.messaging} replace />} />
                      <Route path={InboxesRoutes.messaging}>
                        <Route index element={<Navigate to={InboxesRoutes.general} replace />} />
                        <Route path={InboxesRoutes.general} element={<MessagingGeneral />} />

                        <Route path={InboxesRoutes.smartInbox} element={<SmartInbox />} />
                        <Route
                          path={InboxesRoutes.conversationAssignment}
                          element={<ConversationAssignment />}
                        />
                        <Route path={InboxesRoutes.businessHours} element={<BusinessHours />} />
                        <Route element={<InboxPageAiAutomationAccessLayout />}>
                          <Route
                            path={InboxesRoutes.aiAutomation}
                            element={<MessagingAiAutomation />}
                          />
                        </Route>
                      </Route>
                      <Route path={InboxesRoutes.calling}>
                        <Route index element={<Navigate to={InboxesRoutes.general} replace />} />
                        <Route element={<InboxPageCallingAccessLayout />}>
                          <Route path={InboxesRoutes.general} element={<CallingGeneral />} />
                        </Route>
                        <Route path={InboxesRoutes.smartCallFlow} element={<SmartCallFlow />} />
                      </Route>
                    </Route>
                    <Route index element={<Navigate to={InboxesRoutes.members} replace />} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
          <Route
            path={'*'}
            element={<Navigate to={`/${SettingsRoutes.root}/${InboxesRoutes.root}`} replace />}
          />
        </Route>
      </Route>
    </Routes>
  )
})
